import { Theme } from '@mui/material/styles'

const muiPaginationItem = (theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        margin: '0 0.25rem',
        fontSize: '0.75rem',
        background: theme.colors.subHover,
        '&.Mui-selected': {
          background: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          '&:hover': {
            background: theme.palette.primary.main
          }
        }
      },
      rounded: {
        borderRadius: 8
      },
      ellipsis: {
        background: 'transparent'
      },
      icon: {
        fontSize: '1rem'
      },
      previousNext: {
        background: theme.palette.primary.light,
        color: theme.palette.primary.main,
        '&:hover': {
          background: theme.palette.primary.light
        },
        '&.Mui-disabled': {
          opacity: 1,
          background: theme.colors.stroke,
          color: theme.colors.default
        }
      }
    }
  }
}

export default muiPaginationItem
